import { Flex } from "@eworkit/iris";
import classNames from "classnames";
import React, { FC } from "react";
import { useMedia } from "react-use";

import { Header } from "@/components/Header";
import { Icon } from "@/components/Icon";
import { Text } from "@/components/Text";
import { MEDIA_SIZE_SM } from "@/core/media";
import { TStyleFlexDirection } from "@/eworkitComponents";

import "./_invitation-role-picker-box.scss";

interface IInvitationRolePickerBoxProps {
  header: string;
  icon: string;
  description: string;
  onClick: () => void;
  direction?: TStyleFlexDirection;
  selected?: boolean;
}

export const InvitationRolePickerBox: FC<IInvitationRolePickerBoxProps> = ({
  header,
  icon,
  description,
  onClick,
  direction = "column",
  selected,
}) => {
  const isSmallScreen = useMedia(MEDIA_SIZE_SM);

  const baseClass = "invitation-role-picker-box";

  return (
    <Flex onClick={onClick} flex={1}>
      <Flex
        className={classNames(baseClass, selected && "selected")}
        flexDirection={direction}
        flexGrow={1}
        p={"lg"}
        gap="sm">
        {!isSmallScreen && (
          <Flex>
            <Flex className={`${baseClass}__icon-circle`} alignItems="center" justifyContent="center">
              <Icon className={`${baseClass}__icon`} icon={icon} color="primary" size="xl" />
            </Flex>
          </Flex>
        )}

        <Flex flexDirection="column" gap="sm">
          <Header size="sm" color="black" weight="bold">
            {header}
          </Header>
          <Text size="md" color="black">
            {description}
          </Text>
        </Flex>
      </Flex>
    </Flex>
  );
};
